export default "__VITE_ASSET__Ds668Y6E__"